const { get } = require('./object-helpers');
const AJAX_MODULE_UPDATE_EVENT = 'ajax-module-update-event';
const CATEGORY_FILTER_EVENT = 'categoryFilterEvent';
const SORT_LISTINGS_EVENT = 'sortListingsEvent';
const LOADING_SPINNER_TOGGLE_EVENT = 'str-loading-spinner-toggle-event';

function sendCategoryFilterEvent(cfg) {
    // Need to use links for the SEO, but for ajax, need to prevent the links from navigating.
    // clickEvent.originalEvent is from Marko tag. The other is from a regular HTML tag.
    const elEvent = get(cfg, 'clickEvent.originalEvent') || get(cfg, 'clickEvent');
    if (elEvent && elEvent.target.closest('A')) {
        elEvent.preventDefault();
    }

    const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
        detail: {
            url: cfg.url,
            updateEvent: CATEGORY_FILTER_EVENT,
            type: cfg.type,
            spinnerId: cfg.spinnerId
        }
    });
    document.dispatchEvent(ajaxEvt);
}

function sendSortListingsEvent(cfg) {
    const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
        detail: {
            url: cfg.url,
            updateEvent: SORT_LISTINGS_EVENT,
            errorCallback: cfg.errorCallback
        }
    });
    document.dispatchEvent(ajaxEvt);
}

function loadingSpinnerHide(spinnerId) {
    if (spinnerId) {
        document.dispatchEvent(
            new CustomEvent(LOADING_SPINNER_TOGGLE_EVENT, {
                detail: {
                    id: spinnerId,
                    isShow: false
                }
            })
        );
    }
}

function loadingSpinnerShow(spinnerId) {
    if (spinnerId) {
        document.dispatchEvent(
            new CustomEvent(LOADING_SPINNER_TOGGLE_EVENT, {
                detail: {
                    id: spinnerId,
                    isShow: true
                }
            })
        );
    }
}

function sendPaginateEvent(cfg) {
    const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
        detail: {
            url: cfg.url,
            updateEvent: SORT_LISTINGS_EVENT,
            errorCallback: cfg.errorCallback,
            successCallback: cfg.successCallback,
            spinnerId: 'paginationLoadingSpinner'
        }
    });
    document.dispatchEvent(ajaxEvt);
}

module.exports = {
    sendCategoryFilterEvent,
    sendSortListingsEvent,
    loadingSpinnerHide,
    loadingSpinnerShow,
    sendPaginateEvent
};
